module.exports = __webpack_public_path__ + "img/3_23.402ebbd6.png";